const initialStateMenus = {
    menus: [],
    menus_updated: false,
};

export default initialStateMenus;